import React from 'react';

/*
<div className="preferiti_articolo">
  <div className="preferiti_articolo_img">
    <img
      src="/images/preferiti_articolo_on.svg"
      alt="aggiungi ai preferiti"
    />
  </div>
  <p>Aggiungi ai preferiti</p>
</div>
*/
function WishlistIcon (props) {
    //console.log(props);
    if (props.on === true) {
      return (
        <div className="preferiti_articolo">
          <div
            className="preferiti_articolo_img"
            onClick={(e) => props.toggle(props.id, false)}
          >
            <img
              src="/images/preferiti_articolo.svg"
              alt="rimuovi dai preferiti"
            />
          </div>
          <p>Rimuovi dai preferiti</p>
        </div>
      );
    } else {
        return (
            <div className="preferiti_articolo_on">
            <div
            className="preferiti_articolo_img_on"
            onClick={(e) => props.toggle(props.id, true)}
          >
            <img 
            src="/images/preferiti_articolo_on.svg" 
            alt="aggiungi ai preferiti" />
          </div>
          <p>Aggiungi ai preferiti</p>
          </div>
        );
    }

}

export default WishlistIcon;